import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahUser = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaPeriode, setNamaPeriode] = useState("");
  const [username, setUsername] = useState("");
  const [usernameLama, setUsernameLama] = useState("");
  const [tipeUser, setTipeUser] = useState("");
  const [kodeKwitansi, setKodeKwitansi] = useState("");
  const [coaKasir, setCoaKasir] = useState("");
  const [password, setPassword] = useState("");

  // Akses Master
  const [stok, setStok] = useState(false);
  const [supplier, setSupplier] = useState(false);
  const [mekanik, setMekanik] = useState(false);
  const [bukuBesar, setBukuBesar] = useState(false);
  const [area, setArea] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [tipe, setTipe] = useState(false);
  const [warna, setWarna] = useState(false);
  const [jenisPembayaran, setJenisPembayaran] = useState(false);
  const [cabang, setCabang] = useState(false);

  // Akses Transaksi
  const [pembelian, setPembelian] = useState(false);
  const [returPembelian, setReturPembelian] = useState(false);
  const [pembayaranHutang, setPembayaranHutang] = useState(false);
  const [penjualan, setPenjualan] = useState(false);
  const [pembayaranPiutang, setPembayaranPiutang] = useState(false);
  const [mutasiStok, setMutasiStok] = useState(false);
  const [rekalkulasiStok, setRekalkulasiStok] = useState(false);

  // Akses Laporan
  const [laporanPembelian, setLaporanPembelian] = useState(false);
  const [laporanPenjualan, setLaporanPenjualan] = useState(false);
  const [laporanStok, setLaporanStok] = useState(false);
  const [laporanHutang, setLaporanHutang] = useState(false);
  const [laporanKas, setLaporanKas] = useState(false);

  // Finance
  const [kasMasuk, setKasMasuk] = useState(false);
  const [kasKeluar, setKasKeluar] = useState(false);
  const [bankMasuk, setBankMasuk] = useState(false);
  const [bankKeluar, setBankKeluar] = useState(false);

  // Accounting
  const [posting, setPosting] = useState(false);
  const [unposting, setUnposting] = useState(false);
  const [aktivitasBukuBesar, setAktivitasBukuBesar] = useState(false);
  const [neracaSaldo, setNeracaSaldo] = useState(false);
  const [labaRugi, setLabaRugi] = useState(false);
  const [neraca, setNeraca] = useState(false);
  const [jurnalUmum, setJurnalUmum] = useState(false);

  // Akses Utility
  const [profilUser, setProfilUser] = useState(false);
  const [daftarUser, setDaftarUser] = useState(false);
  const [tutupPeriode, setTutupPeriode] = useState(false);
  const [gantiPeriode, setGantiPeriode] = useState(false);
  const [settingAkses, setSettingAkses] = useState(false);

  // Check All Akses
  const [checkAll, setCheckAll] = useState(false);

  const [cabangs, setCabangs] = useState([]);
  const [coaSubTunais, setCoaSubTunais] = useState([]);
  const [periodesData, setPeriodesData] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const tipeUserOption = ["MANAGER", "ADMIN", "MARKETING", "SURVEYOR"];
  const tipeUserOptionOwner = [
    "OWNER/DIREKSI",
    "MANAGER",
    "ADMIN",
    "MARKETING",
    "SURVEYOR",
  ];
  let coaOptions = coaSubTunais.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));
  let periodeOptions = periodesData.map((periode) => ({
    label: periode.namaPeriode,
  }));

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getPeriodesData();
    getCabangsData();
    getCoaSubTunai();
    getUserById();
  }, []);

  const getPeriodesData = async () => {
    setLoading(true);
    try {
      const allPeriode = await axios.post(`${tempUrl}/tutupPeriodesAsc`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabangId,
      });
      setPeriodesData(allPeriode.data);
    } catch (error) {
      alert(error);
    }
    setLoading(false);
  };

  const getCabangsData = async (kodeUnit) => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
    });
    setCabangs(response.data);
  };

  const getCoaSubTunai = async (kodeUnit) => {
    setCoaKasir("");
    const response = await axios.post(`${tempUrl}/COAsSubGroup`, {
      _id: user.id,
      token: user.token,
      kodeSubGroupCOA: setting.subGroupCoaKas,
    });
    setCoaSubTunais(response.data);
  };

  const getUserById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/findUser/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setUsername(response.data.username);
    setUsernameLama(response.data.username);
    setTipeUser(response.data.tipeUser);
    setNamaPeriode(response.data.tutupperiode.namaPeriode);
    setKodeKwitansi(response.data.kodeKwitansi);
    setCoaKasir(response.data.coaKasir);
    setKodeCabang(response.data.cabang.id);

    // Akses Master
    setStok(response.data.akses.stok);
    setSupplier(response.data.akses.supplier);
    setMekanik(response.data.akses.mekanik);
    setBukuBesar(response.data.akses.bukuBesar);
    setArea(response.data.akses.area);
    setCustomer(response.data.akses.customer);
    setTipe(response.data.akses.tipe);
    setWarna(response.data.akses.warna);
    setJenisPembayaran(response.data.akses.jenisPembayaran);
    setCabang(response.data.akses.cabang);
    setSettingAkses(response.data.akses.setting);

    // Akses Transaksi
    setPembelian(response.data.akses.pembelian);
    setReturPembelian(response.data.akses.returPembelian);
    setPembayaranHutang(response.data.akses.pembayaranHutang);
    setPenjualan(response.data.akses.penjualan);
    setPembayaranPiutang(response.data.akses.pembayaranPiutang);
    setMutasiStok(response.data.akses.mutasiStok);
    setRekalkulasiStok(response.data.akses.rekalkulasiStok);

    // Akses Laporan
    setLaporanPembelian(response.data.akses.laporanPembelian);
    setLaporanPenjualan(response.data.akses.laporanPenjualan);
    setLaporanStok(response.data.akses.laporanStok);
    setLaporanHutang(response.data.akses.laporanHutang);
    setLaporanKas(response.data.akses.laporanKas);

    // Finance
    setKasMasuk(response.data.akses.kasMasuk);
    setKasKeluar(response.data.akses.kasKeluar);
    setBankMasuk(response.data.akses.bankMasuk);
    setBankKeluar(response.data.akses.bankKeluar);

    // Accounting
    setPosting(response.data.akses.posting);
    setUnposting(response.data.akses.unposting);
    setAktivitasBukuBesar(response.data.akses.aktivitasBukuBesar);
    setNeracaSaldo(response.data.akses.neracaSaldo);
    setLabaRugi(response.data.akses.labaRugi);
    setNeraca(response.data.akses.neraca);
    setJurnalUmum(response.data.akses.jurnalUmum);

    // Akses Utility
    setProfilUser(response.data.akses.profilUser);
    setDaftarUser(response.data.akses.daftarUser);
    setTutupPeriode(response.data.akses.tutupPeriode);
    setGantiPeriode(response.data.akses.gantiPeriode);
  };

  const updateUser = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let isFailedValidation =
      form.checkValidity() || coaKasir.length !== 0 || namaPeriode.length !== 0;

    if (isFailedValidation) {
      setLoading(true);
      try {
        let tempUsername = await axios.post(`${tempUrl}/getUsername`, {
          username,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        let isUsernameNotValid =
          tempUsername.data.length > 0 && username !== usernameLama;
        if (isUsernameNotValid) {
          handleClickOpenAlert();
        } else {
          setLoading(true);
          if (password.length === 0) {
            setPassword(user.password);
          }

          await axios.post(`${tempUrl}/users/${id}`, {
            username,
            tipeUser,
            namaPeriode,
            coaKasir,
            password,
            tipeAdmin: user.tipeUser,
            akses: {
              stok,
              supplier,
              mekanik,
              bukuBesar,
              area,
              customer,
              tipe,
              warna,
              jenisPembayaran,
              cabang,
              pembelian,
              returPembelian,
              pembayaranHutang,
              penjualan,
              pembayaranPiutang,
              mutasiStok,
              rekalkulasiStok,
              laporanPembelian,
              laporanPenjualan,
              laporanStok,
              laporanHutang,
              laporanKas,
              kasMasuk,
              kasKeluar,
              bankMasuk,
              bankKeluar,
              posting,
              unposting,
              aktivitasBukuBesar,
              neracaSaldo,
              labaRugi,
              neraca,
              jurnalUmum,
              tutupPeriode,
              gantiPeriode,
              profilUser,
              daftarUser,
              setting: settingAkses,
            },
            cabangId: kodeCabang,
            _id: user.id,
            token: user.token,
          });
          setLoading(false);

          if (user.id == id) {
            dispatch({ type: "LOGOUT" });
            navigate("/");
          } else {
            navigate("/daftarUser");
          }
        }
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah User</h5>
      <Dialog
        open={openAlert}
        onClose={handleCloseAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Data Username Sama`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Username ${username} sudah ada, ganti Username!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert}>Ok</Button>
        </DialogActions>
      </Dialog>
      <hr />
      <Card>
        <Card.Header>User</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateUser}>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Username <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Tipe User <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          required
                          value={tipeUser}
                          onChange={(e) => {
                            setTipeUser(e.target.value);
                          }}
                        >
                          {user.tipeUser === "OWNER/DIREKSI"
                            ? tipeUserOptionOwner.map((tipeUser) => (
                                <option value={tipeUser}>{tipeUser}</option>
                              ))
                            : tipeUserOption.map((tipeUser) => (
                                <option value={tipeUser}>{tipeUser}</option>
                              ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Periode <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={periodeOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && namaPeriode.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setNamaPeriode(value.label);
                            } else {
                              setNamaPeriode("");
                            }
                          }}
                          value={namaPeriode}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      {user.tipeUser === "OWNER/DIREKSI" ? (
                        <Form.Label column sm="3" style={textRight}>
                          Cabang <b style={colorRed}>*</b> :
                        </Form.Label>
                      ) : (
                        <Form.Label column sm="3" style={textRight}>
                          Cabang :
                        </Form.Label>
                      )}
                      <Col sm="9">
                        {user.tipeUser === "OWNER/DIREKSI" ? (
                          <Form.Select
                            required
                            value={kodeCabang}
                            onChange={(e) => {
                              setKodeCabang(e.target.value);
                            }}
                          >
                            {cabangs.map((cabang, index) => (
                              <option value={cabang.id}>
                                {cabang.id} - {cabang.namaCabang}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Control
                            required
                            value={kodeCabang}
                            disabled
                            readOnly
                          />
                        )}
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRightSmall}>
                        Kode Kwitansi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          required
                          value={kodeKwitansi}
                          onChange={(e) => setKodeKwitansi(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        COA Kasir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="9">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && coaKasir.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setCoaKasir(value.label.split(" ", 1)[0]);
                            } else {
                              setCoaKasir("");
                            }
                          }}
                          value={coaKasir}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="3" style={textRight}>
                        Password :
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                          placeholder="Isi jika ingin mengganti Password!"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
            <Container style={{ marginTop: 30 }}>
              <h4>Hak Akses User</h4>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Form>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={checkAll} />}
                        label="Pilih Semua"
                        onChange={() => {
                          setCheckAll(!checkAll);
                          // Akses Master
                          setStok(!checkAll);
                          setSupplier(!checkAll);
                          setMekanik(!checkAll);
                          setBukuBesar(!checkAll);
                          setArea(!checkAll);
                          setCustomer(!checkAll);
                          setTipe(!checkAll);
                          setWarna(!checkAll);
                          setJenisPembayaran(!checkAll);
                          setCabang(!checkAll);
                          // Akses Transaksi
                          setPembelian(!checkAll);
                          setReturPembelian(!checkAll);
                          setPembayaranHutang(!checkAll);
                          setPenjualan(!checkAll);
                          setPembayaranPiutang(!checkAll);
                          setMutasiStok(!checkAll);
                          setRekalkulasiStok(!checkAll);
                          // Akses Laporan
                          setLaporanPembelian(!checkAll);
                          setLaporanPenjualan(!checkAll);
                          setLaporanStok(!checkAll);
                          setLaporanHutang(!checkAll);
                          setLaporanKas(!checkAll);
                          // Finance
                          setKasMasuk(!checkAll);
                          setKasKeluar(!checkAll);
                          setBankMasuk(!checkAll);
                          setBankKeluar(!checkAll);
                          // Accounting
                          setPosting(!checkAll);
                          setUnposting(!checkAll);
                          setAktivitasBukuBesar(!checkAll);
                          setNeracaSaldo(!checkAll);
                          setLabaRugi(!checkAll);
                          setNeraca(!checkAll);
                          setJurnalUmum(!checkAll);
                          // Akses Utility
                          setProfilUser(!checkAll);
                          setDaftarUser(!checkAll);
                          setTutupPeriode(!checkAll);
                          setGantiPeriode(!checkAll);
                          setSettingAkses(!checkAll);
                        }}
                      />
                    </FormGroup>
                  </Form>
                </Box>
              </Box>
              <Box sx={showDataContainer}>
                <Box sx={showDataWrapper}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Master
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bukuBesar} />}
                      label="Buku Besar"
                      onChange={() => setBukuBesar(!bukuBesar)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={area} />}
                      label="Area"
                      onChange={() => setArea(!area)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={stok} />}
                      label="Stok"
                      onChange={() => setStok(!stok)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={supplier} />}
                      label="Supplier"
                      onChange={() => setSupplier(!supplier)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={mekanik} />}
                      label="Mekanik"
                      onChange={() => setMekanik(!mekanik)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={customer} />}
                      label="Customer"
                      onChange={() => setCustomer(!customer)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tipe} />}
                      label="Tipe"
                      onChange={() => setTipe(!tipe)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={warna} />}
                      label="Warna"
                      onChange={() => setWarna(!warna)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jenisPembayaran} />}
                      label="Jenis Pembayaran"
                      onChange={() => setJenisPembayaran(!jenisPembayaran)}
                    />
                  </FormGroup>
                  {/* <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={cabang} />}
                      label="Cabang"
                      onChange={() => setCabang(!cabang)}
                    />
                  </FormGroup> */}
                  <Typography variant="p" sx={[spacingTop]}>
                    Transaksi
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pembelian} />}
                      label="Pembelian"
                      onChange={() => setPembelian(!pembelian)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={returPembelian} />}
                      label="Retur Pembelian"
                      onChange={() => setReturPembelian(!returPembelian)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pembayaranHutang} />}
                      label="Pembayaran Hutang"
                      onChange={() => setPembayaranHutang(!pembayaranHutang)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={penjualan} />}
                      label="Penjualan / Servis"
                      onChange={() => setPenjualan(!penjualan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={pembayaranPiutang} />}
                      label="Penerimaan Piutang"
                      onChange={() => setPembayaranPiutang(!pembayaranPiutang)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={mutasiStok} />}
                      label="Mutasi Stok"
                      onChange={() => setMutasiStok(!mutasiStok)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={rekalkulasiStok} />}
                      label="Rekalkulasi Stok"
                      onChange={() => setRekalkulasiStok(!rekalkulasiStok)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Laporan
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanPembelian} />}
                      label="Laporan Pembelian"
                      onChange={() => setLaporanPembelian(!laporanPembelian)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanPenjualan} />}
                      label="Laporan Penjualan"
                      onChange={() => setLaporanPenjualan(!laporanPenjualan)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanStok} />}
                      label="Laporan Stok"
                      onChange={() => setLaporanStok(!laporanStok)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanHutang} />}
                      label="Laporan Hutang"
                      onChange={() => setLaporanHutang(!laporanHutang)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={laporanKas} />}
                      label="Laporan Kas"
                      onChange={() => setLaporanKas(!laporanKas)}
                    />
                  </FormGroup>
                </Box>
                <Box sx={[showDataWrapper, secondWrapper]}>
                  <Typography variant="p" sx={[spacingTop]}>
                    Finance
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasMasuk} />}
                      label="Kas Masuk"
                      onChange={() => setKasMasuk(!kasMasuk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={kasKeluar} />}
                      label="Kas Keluar"
                      onChange={() => setKasKeluar(!kasKeluar)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankMasuk} />}
                      label="Bank Masuk"
                      onChange={() => setBankMasuk(!bankMasuk)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={bankKeluar} />}
                      label="Bank Keluar"
                      onChange={() => setBankKeluar(!bankKeluar)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Accounting
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={posting} />}
                      label="Posting"
                      onChange={() => setPosting(!posting)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={unposting} />}
                      label="Unposting"
                      onChange={() => setUnposting(!unposting)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={aktivitasBukuBesar} />}
                      label="Aktivitas Buku Besar"
                      onChange={() =>
                        setAktivitasBukuBesar(!aktivitasBukuBesar)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neracaSaldo} />}
                      label="Neraca Saldo"
                      onChange={() => setNeracaSaldo(!neracaSaldo)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={labaRugi} />}
                      label="Laba Rugi"
                      onChange={() => setLabaRugi(!labaRugi)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={neraca} />}
                      label="Neraca"
                      onChange={() => setNeraca(!neraca)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={jurnalUmum} />}
                      label="Jurnal Umum"
                      onChange={() => setJurnalUmum(!jurnalUmum)}
                    />
                  </FormGroup>
                  <Typography variant="p" sx={[spacingTop]}>
                    Utility
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={profilUser} />}
                      label="Profil User"
                      onChange={() => setProfilUser(!profilUser)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={daftarUser} />}
                      label="Daftar User"
                      onChange={() => setDaftarUser(!daftarUser)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={tutupPeriode} />}
                      label="Tutup Periode"
                      onChange={() => setTutupPeriode(!tutupPeriode)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked={gantiPeriode} />}
                      label="Ganti Periode"
                      onChange={() => setGantiPeriode(!gantiPeriode)}
                    />
                  </FormGroup>
                  {user.tipeUser === "OWNER/DIREKSI" && (
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={settingAkses} />}
                        label="Setting"
                        onChange={() => setSettingAkses(!settingAkses)}
                      />
                    </FormGroup>
                  )}
                </Box>
              </Box>
            </Container>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/daftarUser")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                type="submit"
              >
                Edit
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahUser;

const showDataContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const checkboxTitle = {
  marginBottom: 0,
};

const secondCheckboxTitle = {
  marginTop: 15,
  marginBottom: 0,
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};
